import { FC, useEffect } from 'react';
import { CareMapFlow } from './CareMapFlow';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from './CareMapState';
import { isPlatform } from '@ionic/react';
import { CareMapDrawerState } from './CareMapDrawerState';
import { useSubscription } from '@meraki-internal/state';
import { NavigationMenuState } from '../navigation/NavigationMenuState';

export type ICareMapPage = {
    careMapId: string;
};

export const CareMapPage: FC<ICareMapPage> = ({ careMapId }) => {
    const careMapStateInstance = useInstance(CareMapState);
    useSubscription(() => careMapStateInstance);
    const drawerState = useInstance(CareMapDrawerState);
    useSubscription(() => drawerState);
    const navMenuState = useInstance(NavigationMenuState);
    useSubscription(() => navMenuState);

    const isMenuOpen = drawerState.isOpen() || navMenuState.isOpen();

    useEffect(() => {
        if (careMapId !== careMapStateInstance.state?.careMapId) {
            careMapStateInstance.setCurrentCareMap(careMapId);
        }
    }, [careMapId, careMapStateInstance]);

    return (
        <CareMapFlow
            name="full"
            blur={isMenuOpen}
            fit={isMenuOpen ? 'none' : 'custom'}
            includeControls={isPlatform('desktop')}
            careMap={careMapStateInstance.state!}
        />
    );
};
